<template lang="pug">
  div(v-html="value")
</template>

<script>
export default {
  name: 'EHtmlInsert',
  props: {
    value: {
      type: [String, HTMLElement, HTMLCollection],
      default: null
    }
  }
}
</script>

<style scoped lang="scss"></style>
